import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import user from './user.js';
import settings from './settings.js';
import nav from './nav.js';

Vue.use(Vuex);

/* eslint-disable no-new */
const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['user', 'settings']
    })
  ],
  modules: {
    user: user,
    settings: settings,
    nav: nav
  }
});

export default store;
